/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import {
    takeLatest, call, put, fork, select,
} from 'redux-saga/effects';
import mbpLogger from '@module-logger/mbp';

import * as actions from './TalonOneRewards-Actions';
import * as actionTypes from './TalonOneRewards-ActionTypes';
import fetchTalonOneRewards from '../../../../../apis/account-apis/fetchTalonOneRewards';
import { getContactId } from '../Common/Common-Selectors';
import { getAccessTokenSafely } from '../Auth/Plugin/auth/auth';

/**
 * Worker saga to fetch TalonOne rewards data
 */
function* workerFetchTalonOneRewards() {
    try {
        const accessToken = yield call(getAccessTokenSafely);
        const contactId = yield select(getContactId);

        if (!accessToken || !contactId) {
            yield put(actions.fetchTalonOneRewardsFailure('Missing access token or contact ID'));
            return;
        }

        const response = yield call(fetchTalonOneRewards, {
            contactId,
            jwtToken: accessToken,
        });

        if (response && response.data) {
            yield put(actions.fetchTalonOneRewardsSuccess(response.data));
        } else {
            yield put(actions.fetchTalonOneRewardsSuccess(response));
        }
    } catch (error) {
        mbpLogger.logError({
            module: 'mbp-member',
            message: `TalonOneRewards - Failed to fetch rewards: ${error.message}`,
            component: 'TalonOneRewards-Operations',
        });
        yield put(actions.fetchTalonOneRewardsFailure(error.message || 'Failed to fetch rewards'));
    }
}

/**
 * Watcher saga for fetching TalonOne rewards
 */
function* watchFetchTalonOneRewards() {
    yield takeLatest(actionTypes.FETCH_TALON_ONE_REWARDS, workerFetchTalonOneRewards);
}

const watchers = [
    fork(watchFetchTalonOneRewards),
];

const workers = {
    workerFetchTalonOneRewards,
};

export default {
    watchers,
    workers,
};
